<div class="onboarding-button-container" *ngIf="hasOnboarding">
    <ng-content select="p"></ng-content>
    <p i18n="Oboarding alert|info text">Onboarding alert info text</p>
    <button mat-flat-button type="button" [routerLink]="['/onboarding']" i18n="Oboarding alert|button text">To onboarding</button>
</div>
